import { HugeiconsIcon } from "@hugeicons/react";
import {
  Alert02Icon,
  ChangeScreenModeIcon,
  Tick02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { CopyStatus, useCopyToClipboard } from "../hooks/useCopyToClipboard";

const TOOLTIP_CONTENT = {
  [CopyStatus.Idle]: { icon: undefined, label: "Copy" },
  [CopyStatus.Copied]: { icon: Tick02Icon, label: "Copied" },
  [CopyStatus.Error]: { icon: Alert02Icon, label: "Failed to copy" }
};

export const CopyableContactRow = ({
  value,
  displayValue,
  copyAriaLabel
}: {
  value: string;
  displayValue?: string;
  copyAriaLabel: string;
}) => {
  const { status, copy, reset } = useCopyToClipboard();

  const { icon, label } = TOOLTIP_CONTENT[status];

  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-sm font-medium text-content-400 truncate">
        {displayValue || value}
      </span>

      <Tooltip placement="top">
        <TooltipTrigger
          aria-label={status === CopyStatus.Idle ? copyAriaLabel : label}
          className="shrink-0 text-content-400 hover:text-content-600 transition-colors focus:outline-1 focus:outline-primary-500 rounded"
          onMouseEnter={reset}
          onFocus={reset}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            copy(value);
          }}
        >
          <HugeiconsIcon
            icon={ChangeScreenModeIcon}
            size={14}
            strokeWidth={1}
          />
        </TooltipTrigger>

        <TooltipContent className="border border-white/40 rounded-[11px] px-4 py-3 text-sm text-content-1000-inverted z-[13] flex items-center justify-center gap-2">
          {icon ? (
            <HugeiconsIcon icon={icon} size={24} strokeWidth={1} />
          ) : null}
          {label}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
